import { ProductTag } from 'projects/shared/lib/components/shared/product/tag/product-tag.model';
import { PriceTemplateData } from 'projects/shared/lib/components/shared/price/template-data/price-template-data.model';
import { EPackagingType, EProductTag, ProductIdentifierDto, ProductPromotionDto, ProductQuantityScaleItemDto, ProductStockInformationDto, QuantityUnitDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { IConfigurationService } from 'projects/shared/lib/services/infrastructure/configuration/configuration-service.interface';

export class ProductListItem {
  public productIdentifier: ProductIdentifierDto | undefined;
  public thumbnail?: string | undefined;
  public description?: string | undefined;
  public productStockInformation?: ProductStockInformationDto | undefined;
  public productStockIsLoading?: boolean | undefined;
  public minimumOrderAmount?: number;
  public salesUnit?: QuantityUnitDto | undefined;
  public priceTemplateData?: PriceTemplateData | undefined;
  public toolTipText?: string | undefined;
  public isFavorite?: boolean | undefined;
  public quantity?: number | undefined;
  public maximumOrderAmount?: number;
  public quantityScale?: ProductQuantityScaleItemDto[] | undefined;
  public hasAvailabilityNotification?: boolean | undefined;
  public eProductTagList?: EProductTag[] | undefined;
  public productTagList?: ProductTag[] | undefined;
  public promotionDataList?: ProductPromotionDto[] | undefined;
  public packagingType?: EPackagingType | undefined;
  public isWineShopProduct?: boolean | undefined;
  public hasExportBan?: boolean | undefined;

  public constructor(configurationService: IConfigurationService, data?: ProductListItem) {
    this.minimumOrderAmount = 1;
    configurationService.checkoutConfigurationGet().subscribe((checkoutConfiguration) => {
      this.maximumOrderAmount = checkoutConfiguration.maximumOrderAmount;
    });

    if (data != undefined) {
      Object.assign(this, data);
    }
  }
}
